import React, { createContext, useContext, useCallback, useEffect, useState } from "react";
import client from "@/api/client";
import { useAuth } from "@/context/AuthContext";

const BranchContext = createContext(null);
export const useBranch = () => useContext(BranchContext);

export function BranchProvider({ children }) {
  const { user, isAllBranch } = useAuth();
  const [branches, setBranches] = useState([]);
  const [branchId, setBranchId] = useState(
    () => localStorage.getItem("tokoku_branch") || ""
  );

  const reloadBranches = useCallback(() => {
    if (!user) return Promise.resolve();
    return client.get("/branches").then((r) => {
      setBranches(r.data);
      if (!isAllBranch && user.branch_id) {
        setBranchId(user.branch_id);
      }
    });
  }, [user, isAllBranch]);

  useEffect(() => {
    reloadBranches();
  }, [reloadBranches]);

  const selectBranch = (id) => {
    setBranchId(id);
    localStorage.setItem("tokoku_branch", id);
  };

  // effective branch id used in API calls (empty string = all branches)
  const effectiveBranch = isAllBranch ? branchId : user?.branch_id || "";

  const currentBranchName = effectiveBranch
    ? branches.find((b) => b.id === effectiveBranch)?.name || "Cabang"
    : "Semua Cabang";

  return (
    <BranchContext.Provider
      value={{ branches, branchId, selectBranch, effectiveBranch, currentBranchName, isAllBranch, reloadBranches }}
    >
      {children}
    </BranchContext.Provider>
  );
}
